import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useTheme } from './ThemeContext';

const SiteContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function SiteProvider({ children }) {
  const { setTheme } = useTheme();
  const [settings, setSettings] = useState({
    site_name: "Greg's Stuff",
    site_tagline: "Work, Play, and Everything Else",
    contact_email: ""
  });
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSiteData();
  }, []);

  const fetchSiteData = async () => {
    try {
      const [settingsRes, pagesRes] = await Promise.all([
        axios.get(`${API}/settings`),
        axios.get(`${API}/pages?menu_only=true`)
      ]);
      setSettings(settingsRes.data);
      setPages(pagesRes.data);

      // Apply default theme if user hasn't set a preference
      if (!localStorage.getItem('theme') && settingsRes.data.default_theme) {
        setTheme(settingsRes.data.default_theme);
      }
    } catch (error) {
      console.error('Error fetching site data:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateSettings = async (newSettings) => {
    const response = await axios.put(`${API}/settings`, newSettings, {
      withCredentials: true
    });
    setSettings(response.data);
    return response.data;
  };

  const refreshPages = async () => {
    const response = await axios.get(`${API}/pages?menu_only=true`);
    setPages(response.data);
  };

  return (
    <SiteContext.Provider value={{ settings, pages, loading, updateSettings, refreshPages, fetchSiteData }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within a SiteProvider');
  }
  return context;
}
